import{__awaiter as e,__rest as o}from"../../../../../node_modules/tslib/tslib.es6.js";import{shopifyStorefrontClientWrapper as t}from"../../../../../lib/clients.js";import{handleError as r}from"../../../../../lib/error-handler.js";import{gql as i}from"graphql-request";import{shopifyMetaobjectToUnlikelyMetaObject as n}from"../utils/serializers.js";const s=i`
  query GetMetaobject($id: ID, $language: LanguageCode, $country: CountryCode)
  @inContext(language: $language, country: $country) {
    metaobject(id: $id) {
      id
      type
      fields {
        key
        value
      }
    }
  }
`,l=t(((t,i)=>e(void 0,void 0,void 0,(function*(){var{id:e}=i,l=o(i,["id"]);const a={id:e},d=yield t.request(s,Object.assign(Object.assign({},a),l));return{errors:r(null==d?void 0:d.errors),metaobject:(null==d?void 0:d.metaobject)?n(d.metaobject):null}}))));export{l as sfMetaobject};
//# sourceMappingURL=metaobject.js.map
